
export const backendUrl = "https://yopaan-api.applore.in/api"   
//export const backendUrl="http://localhost:9000/api"

//  export const  firebaseConfig = {
//     apiKey: "AIzaSyAiGxPYOUrXinGDjSu4QjOi5X5Z9uVro5I",
//     authDomain: "fireapp-7cada.firebaseapp.com",
//     databaseURL: "https://fireapp-7cada.firebaseio.com",
//     projectId: "fireapp-7cada",
//     storageBucket: "fireapp-7cada.appspot.com",
//     messagingSenderId: "405101290869",
//     appId: "1:405101290869:web:ef1db981033039c46b9f3c"
// }

// orignal config 

export const firebaseConfig = {
  apiKey: "AIzaSyBoHwmMiFLoIGsu_ED7VSI7E4zkjT3HGpY",
  authDomain: "yopaan-5839b.firebaseapp.com",
  projectId: "yopaan-5839b",
  storageBucket: "yopaan-5839b.firebasestorage.app",
  messagingSenderId: "776108413999",
  appId: "1:776108413999:web:280b57e0472dbdc2afa2da",
  measurementId: "G-3KKGJDXDGS"
};



export const defaultCenter = {
    lat: 28.5355,
    lng: 77.3910
}

export const mapApiKey = "AIzaSyBQgBlXexNkV8zXkeT0rB6a7RvJ_YdjCCI"
